import "./LoginRegistrationGroup.scss";

import PropTypes from "prop-types";

import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";
import LinkContainer from "../LinkContainer";
import * as UrlUtil from "../../../api/UrlUtil";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";

type Props = {
    isMetroX?: boolean;
};

export class LoginRegistrationGroup extends React.Component<Props> {
    static contextTypes = {
        router: PropTypes.object,
        intl: PropTypes.object
    };

    trackInteraction(interaction: string) {
        trackStructuredEvent("manual.event", {
            tags: {
                eventCategory: "navigation",
                eventAction: "global header click",
                eventLabel: interaction
            }
        });
    }

    handleLoginClick() {
        const loginPath = UrlUtil.getAbsolutePathForLogin();
        window.location.href = loginPath;
    }

    renderRegistrationLink() {
        const divClass =
            "brandbar-account register-button " + (CountryUtil.getOptionalConfig().signupLink ? "" : "invisible");
        return (
            <div className={divClass}>
                <a className="register-link" href={CountryUtil.getOptionalConfig().signupLink}>
                    <Button
                        onClick={() => this.trackInteraction("sign-up")}
                        bsStyle={this.props.isMetroX ? "inverse" : "link"}>
                        <FormattedMessage id="EX_REGISTER_IN_HEADER" />
                    </Button>
                </a>
            </div>
        );
    }

    renderMetroXLink() {
        return (
            <LinkContainer to={""} onClick={() => this.handleLoginClick()}>
                <div className={"hidden-xs hidden-sm"}>
                    <Button onClick={() => this.trackInteraction("login")} className="btn-primary">
                        <FormattedMessage id="EX_LOGIN_IN_HEADER" />{" "}
                    </Button>
                </div>
                <div className={"hidden-md hidden-lg hidden-xl"}>
                    <Button
                        onClick={() => this.trackInteraction("login")}
                        className="btn-inverse brandbar-mobile-login-button">
                        <FormattedMessage id="EX_LOGIN_IN_HEADER_MOBILE" />{" "}
                        <img
                            src={"/ordercapture/uidispatcher/static/app/assets/images/metroXHeaderAccountIcon.svg"}
                            alt={this.context.intl.formatMessage({ id: "EX_LOGIN_IN_HEADER_MOBILE" })}
                            className={"brandbar-mobile-account-icon"}
                        />
                    </Button>
                </div>
            </LinkContainer>
        );
    }

    renderNonMetroXLink() {
        return (
            <LinkContainer to={""} onClick={() => this.handleLoginClick()}>
                <Button onClick={() => this.trackInteraction("login")} className="btn-inverse">
                    <div className={"hidden-xs hidden-sm"}>
                        <FormattedMessage id="EX_LOGIN_IN_HEADER" />{" "}
                    </div>
                    <div className={"hidden-md hidden-lg hidden-xl"}>
                        <FormattedMessage id="EX_LOGIN_IN_HEADER_MOBILE" />{" "}
                    </div>
                </Button>
            </LinkContainer>
        );
    }

    render() {
        if (SessionStore.pending()) {
            return null;
        }
        return (
            <div>
                <div className="brandbar-account login-button">
                    {this.props.isMetroX ? this.renderMetroXLink() : this.renderNonMetroXLink()}
                </div>
                {CountryUtil.isMarioCountry() && this.renderRegistrationLink()}
            </div>
        );
    }
}

export default LoginRegistrationGroup;
